import React, { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './ContentContainer.module.scss';

interface ContentContainerProps {
  children?: ReactNode;
  className?: string;
}

const ContentContainer: React.FC<ContentContainerProps> = ({ children, className }) => (
  <div
    className={classNames(
      styles.contentContainer,
      'quiver-content-container',
      'sl-section-container',
      className,
    )}
  >
    {children}
  </div>
);

export default ContentContainer;
